/* eslint-disable @typescript-eslint/camelcase */
import { Plugin } from '../../types';

export const record: Plugin = {
  name: 'record',
  page: (emit)=>{
    const win: any = window
    win.rrwebEvents = []
    win.qali.rrwebRecorder({
      emit(event) {
        emit('record', event)
      }
    });
      
  },
  testOnly: true,
  test:{
    collector: true,
    hook: {
      async afterAll(_, context): Promise<void>{
        if(process.env.QALI_REPORT==='true'){
          const getArtifactPath = require('../../utils/getArtifactPath').getArtifactPath
          const artifactPath = getArtifactPath(context._options.testName)
          if(artifactPath){
            const fs = require('fs')
            fs.writeFileSync(artifactPath + '/dom.json', JSON.stringify(context._collectorEvents.filter(({name})=>name==='record')))
          }
        }
      }
    }
  },
}
export default record